import type { z } from 'zod';

import { getBlockText } from '../../../lib/getBlockText.ts';
import { schema as aboutSchema } from '../About/schema.ts';
import { schema as coverImageSchema } from '../CoverImage/schema.ts';
import { schema as linksSchema } from '../Links/schema.ts';
import { schema as whenAndWhereSchemaSingleDate } from '../WhereAndWhenSingleDate/schema.ts';

export const schema = aboutSchema
  .extend(whenAndWhereSchemaSingleDate.shape)
  .extend(coverImageSchema.shape)
  .extend(linksSchema.shape)
  .refine(
    (data) =>
      !(
        !data.description || // Ensure description exists
        !('blocks' in data.description) || // Confirm 'blocks' property is present in description
        (data.description.blocks?.length ?? 0) < 1 || // Check that 'blocks' has at least one item
        getBlockText(data.description.blocks?.[0]) === ''
      ),

    { message: 'required', path: ['description'] },
  )
  .refine(
    (data) => {
      if (data.eventType !== 'live') {
        return true;
      }

      // Check if the 'venue' field is set and is not '0', 0 is the default venue
      if (data.venue && data.venue !== '0') {
        return true;
      }

      if (data.customVenue && data.customVenue.trim() !== '') {
        return true;
      }

      return false;
    },
    {
      message: 'required',
      path: ['venue'], // Highlight the relevant field
    },
  )
  .refine(
    (data) => {
      if (data.eventType !== 'online') {
        return true;
      }

      if (data?.onlineLink?.trim() !== '') {
        return true;
      }
    },
    {
      message: 'required',
      path: ['onlineLink'],
    },
  );

export type EventFormComplete = z.infer<typeof schema>;
